module.exports = {
  REQUIRED: 'Required',
  OPTIONAL: 'Optional',
  NOT_USED: 'NotUsed',
};
